<template>
  <button type="button" class="z-verification" @click="onGetPin">
    {{ time > 0 ? `${time}s后重新获取` : title }}
  </button>
</template>

<script>
import { getPins } from '@/data'
import { regExp } from '@/utils'

let timer = null

export default {
  name: 'ZVerification',
  props: {
    mobile: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'register'
    },
    title: {
      type: String,
      default: '获取手机验证码'
    }
  },
  data() {
    return {
      time: 0,
      loading: false,
      error: ''
    }
  },
  beforeDestroy() {
    timer && clearInterval(timer)
  },
  methods: {
    async onGetPin() {
      if (this.time > 0 || this.loading) return

      const { mobile, type } = this

      if (!mobile) {
        this.$emit('error', { field: 'mobile', message: '请输入手机号' })
        return
      }

      if (!regExp.MOBILE.test(mobile)) {
        this.$emit('error', { field: 'mobile', message: '请输入正确的手机号' })
        return
      }

      this.loading = true
      const { error_code, message, msg, count } = await getPins({ mobile, type })
      this.loading = false

      if (error_code === 0) {
        if (count > 0) {
          this.time = count
          timer && clearInterval(timer)
          timer = setInterval(() => {
            this.time--
          }, 1000)
        }
        this.$emit('success', msg)
      } else {
        this.$emit('error', { field: 'mobile', message })
      }
    }
  }
}
</script>

<style lang="postcss">
.z-verification {
  border: none;
  background-color: #ccc;
  height: 38px;
  font-size: 12px;
  color: #666;
  margin-left: 10px;
  width: 110px;
  border-radius: 5px;
  cursor: pointer;
  vertical-align: top;
}
</style>
